// /app/_store/thunks/timelineSettingsThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { addDays, differenceInCalendarDays } from "date-fns";
import { bookingsApi } from "../api/bookingsApi";
import {
  setTimelineEnd,
  setTimelineLength,
} from "../slices/timelineSettingsSlice";
import { RootState } from "../store";

const emptyOffsetAtTimelineEnd = 31;

export const updateTimelineBounds = createAsyncThunk<
  void,
  { timelineStart: string; animalSpeciesId: number; siteId?: number },
  { state: RootState }
>(
  "timelineSettings/updateTimelineBounds",
  async ({ timelineStart, animalSpeciesId, siteId }, thunkAPI) => {
    const state = thunkAPI.getState();

    const result = bookingsApi.endpoints.getAllBookings.select({
      timelineStart,
      animalSpeciesId,
      siteId,
    })(state);

    const bookings = result?.data;

    if (!Array.isArray(bookings) || bookings.length === 0) return;

    const latestEnd = bookings.reduce<Date | null>((acc, curr) => {
      const d = new Date(curr.EndDate);
      return !acc || d > acc ? d : acc;
    }, null);

    if (!latestEnd) return;

    const paddedEnd = addDays(latestEnd, emptyOffsetAtTimelineEnd);
    const length = differenceInCalendarDays(paddedEnd, new Date(timelineStart));

    thunkAPI.dispatch(setTimelineEnd(paddedEnd.toISOString()));
    thunkAPI.dispatch(setTimelineLength(length));
  }
);
